import { TableDefine } from '@/libs/tableHelper/type'
import { SysConfig } from '@/api/sys/SysConfig'

// 数据表格的列定义
export default function getTableDefine (view: any): TableDefine<SysConfig> {
  const tableCols = [{
    title: '配置名称',
    col: { span: 12 },
    key: 'name'
  }, {
    title: 'key',
    key: 'keyCode'
  }, {
    title: 'value',
    key: 'valueStr'
  }, {
    title: '配置类型',
    key: 'dataType'
  }, {
    title: '图片',
    key: 'imageUrl'
  }, {
    title: '第三方视频点播服务id',
    key: 'videoId'
  }, {
    title: '创建时间',
    type: {
      module: 'time',
      format: 'yyyy-MM-DD HH:mm:ss'
    },
    key: 'createTime'
  }, {
    title: '修改时间',
    type: {
      module: 'time',
      format: 'yyyy-MM-DD HH:mm:ss'
    },
    key: 'updateTime'
  }]

  const actions: any = [{
    name: 'view',
    title: '详情',
    onClick: (dataItem: SysConfig) => {
      view.onViewItem(dataItem)
    }
  }, {
    name: 'edit',
    title: '编辑',
    onClick: (dataItem: SysConfig) => {
      view.onEditItem(dataItem)
    }
  }]

  return {
    tableCols,
    actions
  }
}
